module.exports = __webpack_public_path__ + "img/hy6.86acfa29.png";